<template>
  <div class="rfid-panel rfid-success-container">
    <div class="rfid-success-subtitle title">
      Patrimônios processados com sucesso!
    </div>
    <div class="rfid-success-icon">
      <i class="fa-light fa-circle-check"></i>
    </div>
    <div class="rfid-success-btn">
      <Button
        _key="btnBack"
        type="info"
        size="small"
        title="Voltar"
        classIcon="fa-solid fa-arrow-left"
        :clicked="goBack"
      />
    </div>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import { mapMutations } from "vuex";

export default {
  name: "ProductRfidSuccess",
  components: { Button },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    goBack() {
      this.$emit("back");
      this.removeLoading(["btnBack"]);
    },
  },
};
</script>

<style scoped>
.rfid-panel {
  width: 556px !important;
  margin: auto;
  border: 1px solid #e5e7eb;
  border-radius: 15px;
  background: #fff;
  padding: 30px;
  text-align: center;
}

.rfid-success-container {
  padding: 40px 20px;
}

.rfid-success-icon i {
  font-size: 50px;
  color: #16a34a;
  margin-bottom: 15px;
}

.rfid-success-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}

.rfid-success-subtitle {
  font-size: 18px;
  margin-bottom: 25px;
}

.rfid-success-btn {
  margin-top: 10px;
}
</style>
